import type { ScraperPreviewResult, UnfinishedScrape } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/Scraper/Scraper.Controller.ts

export class ScraperAPI {
  static async previewScrape(url: string, orgId: number): Promise<ScraperPreviewResult> {
    return APIService.Server.post<ScraperPreviewResult>(`/scraper/org/${orgId}/preview`, { url });
  }

  static async listUnfinished(orgId: number): Promise<UnfinishedScrape[]> {
    return APIService.Server.get<UnfinishedScrape[]>(`/scraper/org/${orgId}/unfinished`);
  }

  static async rebuildPreview(orgId: number, id: number): Promise<ScraperPreviewResult> {
    return APIService.Server.get<ScraperPreviewResult>(`/scraper/org/${orgId}/unfinished/${id}/preview`);
  }

  static async discardUnfinished(orgId: number, id: number): Promise<void> {
    return APIService.Server.delete<void>(`/scraper/org/${orgId}/unfinished/${id}`);
  }
}
